<h4 class="grey-text mb-3">Enable two-factor authentication</h4>
<mat-dialog-content>
  <p class="mb-4">Two-factor authentication requires you to use a so called TOTP (Time-based One Time Password) authentication<br>
    app on your smartphone, like Google Authenticator or Authy. Follow the steps below to add DDS Signage to your TOTP<br>
    authentication app. The next time you log in you will go through an additional step where you fill in the unique<br>
    time-based code that is generated by your personal app.
  </p>
  <div class="row">
    <div class="col-sm-12 col-md-6 col-lg-6">
      <h5 class="grey-text">1. Scan the QR code</h5>
      <hr>
      <img [src]="qrCodePath" alt="QRCode" class="qr-code-img">
      <p class="validation-message">If you cannot scan, please enter the following code
        manually: <span class="validation-message-code">{{ validationData.ManualCode }}</span>
      </p>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-6">
      <h5 class="grey-text">2. Confirm the OTP code</h5>
      <hr>
      <form #form="ngForm" (ngSubmit)='save()'>
        <div class="row mb-2">
          <div class="col-12">
            <mat-form-field>
              <mat-label>Code</mat-label>
              <input matInput placeholder="Code" #code="ngModel" name="code" [(ngModel)]="validateModel.Code" required>
              <mat-error *ngIf="code.invalid && code.hasError('required')">This field is required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field>
              <mat-label>Your password</mat-label>
              <input matInput placeholder="Enter your password" #pass="ngModel"
                name="pass" [type]="hidePass ? 'password' : 'text'" [(ngModel)]="validateModel.Password" required>
              <mat-icon matTooltip="Hide/Show Password" matSuffix (click)="hidePass = !hidePass"
                [svgIcon]="hidePass ? 'visibility_off' : 'visibility'"></mat-icon>
              <mat-error *ngIf="pass.invalid && pass.hasError('required')">This field is required</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <button mat-raised-button class="btn-green" [disabled]="form.invalid" #submit type="submit">Confirm</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <mat-icon class="close-button" (click)="onClose()" svgIcon="close" matTooltip="Close"></mat-icon>
</mat-dialog-content>
